const config = {
    sso_api: `${process.env.REACT_APP_LIVE_PRODUCTION_URL_SSO}/api/`,
    api_url: `${process.env.REACT_APP_LIVE_PRODUCTION_URL_ECOMMERENCE}/api/`,
    xox_url: `${process.env.REACT_APP_BLACK_API_GATEWAY}/api/`,
    session: `${process.env.REACT_APP_LEGACY_BLACK_API_BACKEND}/api/v3/session/create`,
    fcmKey: "testFcmKey",
    google_map_key: process.env.REACT_APP_GOOGLE_MAP_KEY,
};
export default config;
